import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Card, Chip, Divider, Grid, Stack, Typography } from '@curves/ui-base';
import { formatCurrencyFn } from '@Util/utils';
import { PRICE_FIELDS } from '@Local/Product/priceFields';

/** 價格以 NT$ 格式顯示，空值顯示「-」 */
const formatPrice = (value) => (value === null || value === undefined ? '-' : formatCurrencyFn(value, { symbol: 'NT$ ' }));

/** 商品明細的單張規格卡片（規格名稱、SKU、各項價格） */
const ProductDetailVariantCard = ({ variant, isMain }) => {
    const priceItems = PRICE_FIELDS.map(({ field, label, isHighlight }) => ({ label, value: variant[field], isHighlight }));

    return (
        <Card className="product-variant-card p-3">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography className="mb-0">規格名稱：{variant.variantName || '-'}</Typography>
                    {isMain && <Chip label="主規格" color="primary" size="small" />}
                </Stack>
                <Typography className="product-variant-card__sku mb-0">SKU：{variant.sku || '-'}</Typography>
            </Stack>
            <Divider className="my-2" />
            <Grid container spacing={2}>
                {priceItems.map(({ label, value, isHighlight }) => (
                    <Grid item xs={4} key={label}>
                        <Typography className="product-variant-card__label mb-0">{label}</Typography>
                        <Typography className={clsx('product-variant-card__value mb-0', isHighlight && 'text-primary')}>{formatPrice(value)}</Typography>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
};

ProductDetailVariantCard.propTypes = {
    variant: PropTypes.shape({
        variantName: PropTypes.string,
        sku: PropTypes.string,
        originalPrice: PropTypes.number,
        costPrice: PropTypes.number,
        salePrice: PropTypes.number,
        memberPrice: PropTypes.number,
        discountPrice: PropTypes.number,
    }).isRequired,
    isMain: PropTypes.bool,
};

ProductDetailVariantCard.defaultProps = {
    isMain: false,
};

export default ProductDetailVariantCard;
